export const DVTJCUVCddOpenAndNotSddvParentTabs = {
    PRIORITY_PROCESS_TAB: {title: 'ƯU TIÊN XỬ LÝ', id: 'dvtjcuv-cdd-open-and-not-sddv-priority-process-tab'},
    NEED_TO_MAKE_BRIEF_TAB: {title: 'CẦN LÀM BRIEF', id: 'dvtjcuv-cdd-open-and-not-sddv-need-to-make-brief-tab'},
    NEW_CDDS_TAB: {title: '1-NEW CDDS', id: 'dvtjcuv-cdd-open-and-not-sddv-new-cdds-tab'},
    BRIEF_SENT_TAB: {title: '2-BRIEF SENT', id: 'dvtjcuv-cdd-open-and-not-sddv-brief-sent-tab'},
};


export const DVTJCUVCddOpenAndNotSddvNeedToMakeBriefTabs = {
    NOT_HAVE_BRIEF_TAB: {title: 'Chưa có Brief', id: 'not-have-brief-tab'},
    HAVE_LESS_1_YEAR_BRIEF_TAB: {title: 'Có rồi, cách < 1 năm', id: 'have-less-1-year-brief-tab'},
    HAVE_1_2_YEAR_BRIEF_TAB: {title: 'Có rồi, cách 1-2 năm', id: 'have-1-2-year-brief-tab'},
    HAVE_MORE_2_YEAR_BRIEF_TAB: {title: 'Có rồi, cách > 2 năm', id: 'have-more-2-year-brief-tab'}
};


export const DVTJCUVCddOpenAndNotSddvBriefSentTabs = {
    OFFERING_TAB: {title: '2.1-Offering', id: 'offering-tab'},
    INTERVIEWING_TAB: {title: '2.2-Interviewing', id: 'interviewing-tab'},
    CV_SENT_TAB: {title: '2.3-CV sent', id: 'cv-sent-tab'},
    EMP_SHARED_JOB_TAB: {title: '2.4-Emp shared job', id: 'emp-shared-job-tab'},
    NEED_TO_FIND_MORE_EMP_TAB: {title: '2.5-Need to Find more Emp', id: 'need-to-find-more-emp-tab'},
    OTHERS_TAB: {title: '2.6-Others', id: 'others-tab'}
};


export const DVTJCUVCddOpenAndNotSddvFUReceiverTabs = {
    RECEIVER_LIST_NEED_FU_TAB: {title: '3.1-List Receivers cần FU', id: 'dvtjcuv-connect-cdd-emp-fu-receivers-need-fu-tab'},
    SEND_EMAIL_TAB: {title: '3.2-Gửi email', id: 'dvtjcuv-connect-cdd-emp-fu-receivers-send-email-tab'},
};


export const DVTJCUVCddOpenAndNotSddvSendEmailReceiverUpdateInfoTabs = {
    RECEIVER_LIST_TAB: {title: '4.1-List Receivers', id: 'email-dn_update-info-receiver-list-tab'},
    SEND_EMAIL_TAB: {title: '4.2-Gửi email', id: 'email-dn_update-info-send-email-tab'},
    // FOLLOW_UP_TAB: {title: '4.3-FU', id: 'email-dn_update-info-follow-up-tab'}
};

export const DVTJCUVCddOpenAndNotSddvSendEmailTabs = {
    DRAFT_TAB: {title: '4.2.1-Duyệt Draft & Gửi email', id: 'draft-tab'},
    NOT_PERMISSION_EMAIL_TAB: {title: '4.2.2-Person bạn chưa có quyền gửi email', id: 'not-permission-email-tab'},
    NEED_CHECKING_TAB: {title: '4.2.3-Person need checking', id: 'need-checking-tab'},
    NEED_INPUT_INFO_TAB: {title: '4.2.4-Person cần nhập bổ sung ttin', id: 'need-input-info-tab'},
    SEND_WHEN_UNLIMITED_TAB: {title: '4.2.5-Person chờ hạn mức', id: 'send-when-unlimited-tab'},
    EXPORTED_WAITING_SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB: {title: '4.2.6-UV đã export, chờ NL Gửi email Đề nghị Receiver update info', id: 'exported-waiting-send-email-tab'}
};

export const DVTJCUVCddOpenAndNotSddvFUReceiverSendEmailTabs = {
    DRAFT_TAB: {title: '3.2.1-Duyệt Draft', id: 'draft-tab'},
    NOT_PERMISSION_EMAIL_TAB: {title: '3.2.2-Person bạn chưa có quyền gửi email', id: 'not-permission-email-tab'},
    NEED_CHECKING_TAB: {title: '3.2.3-Person need checking', id: 'need-checking-tab'},
    NEED_INPUT_INFO_TAB: {title: '3.2.4-Person cần nhập bổ sung ttin', id: 'need-input-info-tab'},
    SEND_WHEN_UNLIMITED_TAB: {title: '3.2.5-Person chờ hạn mức', id: 'send-when-unlimited-tab'},
    EXPORTED_WAITING_SEND_EMAIL_TAB: {title: '3.2.6-UV đã export', id: 'exported-waiting-send-email-tab'}
};

